import { tokens } from "@blurb/codex-react";
import { createStyles } from "@mantine/core";
import React from "react";
import { Body, Label } from "../../components/Typography";

interface RpaDrawerFieldProps {
  label: React.ReactNode;
  children: React.ReactNode;
  "data-testid"?: string;
}

const useStyles = createStyles({
  field: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacing[1],
    width: "100%",
    minWidth: 0,
    overflowWrap: "anywhere",
  },
});

export const RpaDrawerField: React.FC<RpaDrawerFieldProps> = ({ label, children, "data-testid": testId }) => {
  const { classes } = useStyles();
  return (
    <div className={classes.field} data-testid={testId}>
      <Label size="base" weight="semibold">
        {label}
      </Label>
      <Body size="base" weight="normal">
        {children}
      </Body>
    </div>
  );
};
